export default __webpack_public_path__ + "static/media/background.3cc5ec12.jpg";